export default {"src":"/_next/static/media/share.406f3ea7.svg","height":36,"width":36};